export default "/assets/images/payment-methods.a0d63e1d64034907.png";